import { useContext, useEffect } from "react";

import { Grid } from "@material-ui/core";

import { QueryParamsContext } from "../../../context/QueryParamsContext";
import Loading from "../../../components/basics/Loading";
import HeaderModule from "../../../components/header/HeaderModule";
import {
  IntermediadorContext,
  IntermediadorContextProvider,
} from "./contexts/IntermediadorContext";
import Btn from "../../../components/buttons/Btn";
import { PainelContainer } from "../../prouser/fornecedores/styles/Fornecedor";
import AccordionIntermediadoresGeral from "./children/AccordionIntermediadorGeral";
import useIntermediadorController from "./controllers/IntermediadorController";
import { showOrigem } from "../../../repository/ERP/vendas/OrigemService";

const View = ({ location }) => {
  const { queryParams } = useContext(QueryParamsContext);

  const {
    setIntermediadorIdNew,
    setIntermediadorCnpjNew,
    setIntermediadorAtivoNew,
    setIsIntermediadorNew,
    setIntermediadorRazaoNew,
    setIdentificadorUsuarioNew,
    setIntermediadorDescricaoNew,
    setEstoquesIdNew,
    estoquesId,
    loading,
    setLoading,
  } = useContext(IntermediadorContext);

  const { handleSubmit, handleBackSubmit } = useIntermediadorController();

  //useEffect que carrega os dados da ediçao; se for inclusão ele limpa os campos
  useEffect(() => {
    const idIntermediary = location?.state?.item?.id;
    if (!idIntermediary) {
      setIntermediadorCnpjNew("");
      setIntermediadorRazaoNew("");
      setIdentificadorUsuarioNew("");
      setIntermediadorDescricaoNew("");
      setEstoquesIdNew([]);
      setIntermediadorAtivoNew(true);
      setIsIntermediadorNew(true);

      return;
    }
    (async () => {
      setLoading(true);
      try {
        const dataIntermediary = await showOrigem(
          idIntermediary,
          queryParams.empresa_cnpj,
          "localEstoque"
        );

        const { data } = dataIntermediary;

        setIntermediadorIdNew(idIntermediary);
        setIntermediadorCnpjNew(data.cnpj || "");
        setIntermediadorRazaoNew(data.razao || "");
        setIdentificadorUsuarioNew(data.identificador_usuario || "");
        setIntermediadorDescricaoNew(data.descricao || "");
        setEstoquesIdNew(data.local_estoque || []);
        setIntermediadorAtivoNew(data.ativo);
        setIsIntermediadorNew(data.intermediador);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    })();
  }, [
    location,
    queryParams.empresa_cnpj,
    setIntermediadorIdNew,
    setLoading,
    estoquesId,
    setEstoquesIdNew,
    setIdentificadorUsuarioNew,
    setIntermediadorAtivoNew,
    setIntermediadorCnpjNew,
    setIntermediadorDescricaoNew,
    setIntermediadorRazaoNew,
    setIsIntermediadorNew,
  ]);

  return (
    <>
      <HeaderModule
        title="CADASTRO DE INTERMEDIADOR/MARKETPLACE"
        textcolor="black"
      />

      <Loading open={loading} />

      <PainelContainer maxWidth="xl">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <AccordionIntermediadoresGeral />
          </Grid>
        </Grid>

        <Grid container spacing={2} justifyContent="flex-end">
          <Grid item>
            <Btn
              label="Voltar"
              bgcolor="tertiary"
              onClick={() => handleBackSubmit()}
            />
          </Grid>
          <Grid item>
            <Btn label="Salvar" onClick={() => handleSubmit(false)} />
          </Grid>
          <Grid item>
            <Btn label="Salvar e Novo" onClick={() => handleSubmit(true)} />
          </Grid>
        </Grid>
      </PainelContainer>
    </>
  );
};

const IntermediadoresCadastro = ({ ...props }) => (
  <IntermediadorContextProvider>
    <View {...props} />
  </IntermediadorContextProvider>
);

export default IntermediadoresCadastro;
